import { render, staticRenderFns } from "./doctorEMRClinics.vue?vue&type=template&id=4b965cfa&"
import script from "./doctorEMRClinics.vue?vue&type=script&lang=js&"
export * from "./doctorEMRClinics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports